export default __webpack_public_path__ + "static/8-3--c12c6cb4937587ef5f10df18d3c2dc30.png";